import AttendanceSerializer from './base';

export default class Record extends AttendanceSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      code: '',
      notes: '',
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }

  serialize(snapshot) {
    let hash = super.serialize(...arguments);
    hash.homeroomId =
      snapshot.belongsTo('personId').record.get('homeroom.id') || '';
    return hash;
  }
}
